module.exports = __webpack_public_path__ + "img/quizzz-1.283d7bfa.jpg";